import { Megaphone } from "lucide-react";

const SIZES = { sm: "w-9 h-9 text-xs", md: "w-11 h-11 text-sm", xl: "w-24 h-24 text-3xl" };
const TONES = ["bg-klein", "bg-emerald-600", "bg-amber-600", "bg-rose-600", "bg-sky-600", "bg-violet-600", "bg-teal-600"];

const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "?";
const tone = (name = "") => TONES[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % TONES.length];

export function Avatar({ name, size = "md", online, group, announce }) {
    return (
        <div className="relative shrink-0">
            <div className={`${SIZES[size]} ${announce ? "bg-terracotta" : group ? "bg-ink" : tone(name)} rounded-full flex items-center justify-center text-white font-semibold`}>
                {announce ? <Megaphone className="w-5 h-5" /> : initials(name)}
            </div>
            {online !== undefined && (
                <span className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white ${online ? "bg-emerald-500" : "bg-ink/25"}`} />
            )}
        </div>
    );
}

export default Avatar;
